import { CpLobby } from '@/components/chinesepoker/CpLobby';

/**
 * Hub "Gioca" section for Chinese Poker: the full lobby controls (vs bot,
 * ranked queue, friend invite, accept code, rules) minus the leaderboard
 * peek — the Hub has a dedicated Classifica section. ownScroll panel.
 *
 * `-mx-4` cancels the Hub's own `px-4` (see HubSections → Hub.tsx) since
 * `CpLobby` brings its own `px-4 py-4` — same reasoning as EventsPanel /
 * CommunityPanel / SitngoPanel with `Tournaments`. Unlike `Tournaments`,
 * `CpLobby` doesn't manage its own internal scroll region (it's a plain
 * stacked list of controls, no `overflow-y-auto` of its own), so this panel
 * supplies `min-h-0 flex-1 overflow-y-auto` itself — the contract HubSections
 * expects from an `ownScroll: true` panel (its wrapper clips with
 * `overflow-hidden`, so the panel must be the one that scrolls).
 */
export function QcpPlayPanel() {
  return (
    <div className="-mx-4 min-h-0 flex-1 overflow-y-auto">
      <CpLobby showLeaderboard={false} />
    </div>
  );
}
